<template>
    <div>
        <form @submit.prevent="openSubmitModal">
            <div class="score-wrapper my-4">
                <div class="label label-small mb-0"><strong>Clear Interest/Career Goals:</strong></div>
                <div class="label label-small font-italic grey-text">Has the applicant fully conveyed their passion and commitment to
                    their television career?
                </div>
                <RadioButtonGroup class="mt-2" name="q_1" v-model="judgementValues.q_1" :options="scoreOptions" :disabled="alreadySubmitted"/>
            </div>
            <div class="score-wrapper my-4">
                <div class="label label-small mb-0"><strong>Maturity/Sincerity:</strong></div>
                <div class="label label-small font-italic grey-text">These are important qualities for an intern to be successful.
                    Rank your impression of how they’ve expressed this.
                </div>
                <RadioButtonGroup class="mt-2" name="q_2" v-model="judgementValues.q_2" :options="scoreOptions" :disabled="alreadySubmitted"/>
            </div>
            <div class="score-wrapper my-4">
                <div class="label label-small mb-0"><strong>Perceived Talent/Abilities:</strong></div>
                <div class="label label-small font-italic grey-text">Do you think this applicant has what it takes to maximize this
                    internship opportunity?
                </div>
                <RadioButtonGroup class="mt-2" name="q_3" v-model="judgementValues.q_3" :options="scoreOptions" :disabled="alreadySubmitted"/>
            </div>
            <div class="score-wrapper my-4">
                <div class="label label-small mb-0"><strong>The Foundation has a clear commitment to opening doors to the
                    television industry.</strong></div>
                <div class="label label-small font-italic grey-text">Based on your review of the material (background, no evident
                    business connections, etc.), does this applicant merit additional consideration because he/she may not
                    otherwise have access to the industry without this internship opportunity?
                </div>
                <RadioButtonGroup class="mt-2 wide text-uppercase" name="q_4" :class="judgementValues.q_4 ? 'judgement-yes-no--selected' : ''" v-model="judgementValues.q_4"
                                  :options="yesNoOptions" :disabled="alreadySubmitted"/>
            </div>

            <div class="pt-4 border-top" v-if="!alreadySubmitted">
                <p class="small greyed-light my-2">By clicking 'Submit' you confirm that you have viewed the documentation
                    for this application.</p>
                <button type="submit"
                        :disabled="submitDisabled"
                        class="submit-button btn btn-primary btn-bigger-font"
                >
                    <checkmark></checkmark> Submit
                </button>
            </div>
            <div class="pt-4 border-top" v-else>
                <p class="small greyed-light my-2">
                    You have already submitted your scores for this entry.
                </p>

                <a :href="return_link" class="submit-button btn btn-primary btn-bigger-font">
                    <checkmark></checkmark> Next Entry
                </a>
            </div>
        </form>

        <modal v-if="submitOrderModal" @close="submitOrderModal = false">
            <template #header>
                <h1 class="text-center w-100 mb-0">
                    Submit Vote
                </h1>
            </template>
            <template #body>
                <div class="content text-center py-2 modal-body-restrict">
                    <div v-if="!submitting">
                        <p>
                            I am ready to submit my vote and understand that I will not be able to print, alter, or rescind my vote once I have done so.
                        </p>
                    </div>
                    <div v-else>
                        <spinner></spinner>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="form-group-submit">
                    <div v-if="!submitting">
                        <button type="button" class="btn btn-primary pull-left" @click="submitOrderModal = false">
                            <close-icon></close-icon>
                            Close
                        </button>
                        <button type="button" class="btn btn-primary pull-right" @click="performSubmit">
                            <checkmark></checkmark>
                            Submit
                        </button>
                    </div>
                </div>
            </template>
        </modal>

        <modal v-if="successModal" :showHeader="false" :showFooter="false">
            <template #body>
                <div class="content">
                    <div v-html="success_html">

                    </div>
                </div>
            </template>
        </modal>
    </div>

</template>

<script>
import Modal from "./Modal.vue";
import RadioButtonGroup from "./RadioButtonGroup.vue";
import Checkmark from "../Icons/checkmark.vue";
import CloseIcon from "../Icons/close.vue";
import Spinner from "../Icons/spinner.vue";
import eventBus from "./eventBus";

export default {
    components: {
        RadioButtonGroup,
        Modal,
        Checkmark,
        CloseIcon,
        Spinner,
    },
    props: {
        return_link: {
            type: String,
            required: true
        },
        submitUrl: {
            type: String,
            required: true,
        },
        judgement: {
            type: Object,
        },
        alreadySubmitted: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            judgementValues: {...this.judgement},

            submitOrderModal: false,
            submitting: false,

            successModal: false,
            success_html: '',

            scoreOptions: [1, 2, 3, 4, 5].map(score => {
                return {
                    value: score,
                    label: score
                };
            }),

            yesNoOptions: [
                {value: 1, label: 'Yes'},
                {value: 0, label: 'No'},
            ],
        }
    },
    computed: {
        allQuestionsAnswered() {
            const {q_1, q_2, q_3, q_4} = this.judgementValues;
            return q_1 !== null && q_2 !== null && q_3 !== null && q_4 !== null
                && typeof q_1 !== 'undefined' && typeof q_2 !== 'undefined' && typeof q_3 !== 'undefined' && typeof q_4 !== 'undefined'
                ;
        },

        submitDisabled() {
            return !this.allQuestionsAnswered;
        },
    },
    methods: {
        openSubmitModal() {
            if (this.submitDisabled || this.alreadySubmitted) {
                return;
            }
            this.submitOrderModal = true;
        },
        performSubmit() {
            this.submitting = true;
            this.flashMessage = null;
            axios.post(this.submitUrl, {
                q_1: this.judgementValues.q_1,
                q_2: this.judgementValues.q_2,
                q_3: this.judgementValues.q_3,
                q_4: this.judgementValues.q_4,
            }).then(response => {
                // User tried to submit after judging was closed. Instead of showing an empty modal,
                // reload the page to get automatic redirect to the closed page.
                if (response.headers && response.headers['x-judging-closed'] === '1') {
                    window.location.reload();
                }
                this.submitting = false;
                this.submitOrderModal = false;
                this.successModal = true;
                this.success_html = response.data.success_html;
            }).catch(error => {
                this.submitting = false;
                this.submitOrderModal = false;

                let isUnexpectedError = !error.response || !error.response.data || !error.response.data.message;

                if (isUnexpectedError) {
                    console.error('Unexpected error during submission', error);
                }

                eventBus.emit('flashMessage', {
                    'level': 'danger',
                    'message': isUnexpectedError
                        ? 'An unexpected error occurred while submitting your scores. Please check your internet connection and try again.'
                        : error.response.data.message,
                });
            });
        },
    }
}

</script>
<style>
.grey-text { color:#969696; font-size:14px;}
</style>